import { takeLatest, put, call, SagaReturnType } from 'redux-saga/effects';
import { departmentDashboard } from '../../actions/constant';
import departmentDashboardService from '../../../services/departmentDashboard/getDepartmentDashboardCount';

const {
  GET_PHYSICIAN_SIGNATURE_PENDING_REQUEST,
  GET_PHYSICIAN_SIGNATURE_PENDING_SUCCESS,
  GET_PHYSICIAN_SIGNATURE_PENDING_FAILURE,
  GET_PHYSICIAN_SIGNATURE_PENDING_LOADING,
} = departmentDashboard;

function* getPhysicianSignaturePending(action: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_PHYSICIAN_SIGNATURE_PENDING_LOADING });
    const response = yield call(
      departmentDashboardService.getPhysicianSignaturePending,
      action.payload
    );
    if (response?.status === 200) {
      yield put({ type: GET_PHYSICIAN_SIGNATURE_PENDING_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_PHYSICIAN_SIGNATURE_PENDING_FAILURE, payload: error });
  }
}

function* getPhysicianSignaturePendingSaga() {
  yield takeLatest(GET_PHYSICIAN_SIGNATURE_PENDING_REQUEST, getPhysicianSignaturePending);
}

export default getPhysicianSignaturePendingSaga;
